/// <reference path="main/ambient/es6-shim/index.d.ts" />
/// <reference path="main/ambient/googlemaps/googlemaps.d.ts" />
